module.exports = __webpack_public_path__ + "img/touxian.4ba85fa4.png";